import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

interface Notification {
  id: string;
  isRead: boolean;
}

export function useNotifications(playerId: string | null) {
  const { data: notifications = [] } = useQuery<Notification[]>({
    queryKey: ["/api/notifications"],
    queryFn: async () => {
      const response = await apiRequest("GET", "/api/notifications");
      return response.json();
    },
    enabled: !!playerId,
    refetchOnWindowFocus: true,
    staleTime: 30000,
  });

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return { unreadCount, notifications };
}

